import React from 'react'
import PropTypes from 'prop-types'

import ProgressBar from '@components/progress-bar/progress-bar.component'
import Icon from '@components/icon/icon.component'

import i18n from 'i18n-js'
import { NO_RESPONSE, USER, USERS } from '../../assets/i18n/strings'

import useStyles from './engagement-detail-list-item.style'

const EngagementDetailListItem = (props) => {
  const { noNoResponse, noSent, suggestion, rightComponent, onClick, progressColor } = props
  const { cta_reference: ctaReference, no_responses: numResponses, text, type } = suggestion

  const strokeColor = type === 'no-response' ? 'darkgray' : `#${progressColor}`

  const handleOnClick = () => onClick(suggestion)

  const responseCount = type === 'no-response' ? noNoResponse : numResponses

  const progress = responseCount / noSent * 100

  const renderUserText = () => {
    const checkCount = `${responseCount} ${responseCount === 1 ? i18n.t(USER) : i18n.t(USERS)}`

    const checkType = type !== 'no-response' ? ' responded' : ''

    return checkCount + checkType
  }

  const renderRightComponent = () => {
    if (disabled) return null

    const checkRightComponent = ctaReference ? rightComponent : <Icon type='circle-plus' />

    return checkRightComponent
  }

  const disabled = responseCount === 0

  const classes = useStyles({ ...props, disabled })

  return (
    <div className={classes.wrapper}>
      <li
        className={classes.listItem}
        onClick={handleOnClick}
      >
        <div className={classes.text}>
          <div className={classes.title}>{type === 'no-response' ? i18n.t(NO_RESPONSE) : text}</div>
          <ProgressBar
            progress={progress}
            strokeColor={strokeColor}
          />
          <div className={classes.responses}>{renderUserText()}</div>
        </div>
        <div className={classes.rightComponentContainer}>{renderRightComponent()}</div>
      </li>
    </div>
  )
}


EngagementDetailListItem.defaultProps = {
  numResponses: 0,
  numSent: 0,
  suggestion: {},
  rightComponent: <Icon type='caret-right' />,
  title: ''
}

EngagementDetailListItem.propTypes = {
  numResponses: PropTypes.number,
  numSent: PropTypes.number,
  suggestion: PropTypes.object,
  rightComponent: PropTypes.node,
  title: PropTypes.string
}

export default EngagementDetailListItem
